/// <reference path="./chessboard.d.ts" />

import { Component, Input, Output, OnInit, HostListener, EventEmitter } from '@angular/core';
export class ChessboardComponent implements OnInit {

  board: any;
private _position:      any     = 'start';
private _orientation:   Boolean = true;
private _showNotation:  Boolean = true;
private _draggable:     Boolean = false;
private _dropOffBoard:  string  = 'snapback';
private _pieceTheme:    any     = 'img/chesspieces/wikipedia/{piece}.png';
private _moveSpeed:     any     = 200;
private _snapbackSpeed: any     = 500;
private _snapSpeed:     any     = 100;
private _sparePieces:   Boolean = false;

   animation: Boolean = true;
   animationChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
constructor() {}
/**
 * @param {?} event
 * @return {?}
 */
onResize(event){
    if (this.board) this.board.resize(event);
  }
/**
 * @param {?} value
 * @return {?}
 */
set position(value: any) {
    this._position = value;
    if (this.board) this.board.position(value, this.animation);
  }
/**
 * @param {?} value
 * @return {?}
 */
set orientation(value: Boolean) {
    this._orientation = value;
    if(this.board) this.board.orientation(value ? 'white' : 'black');
    this.orientationChange.emit(this._orientation);
  }
/**
 * @param {?} value
 * @return {?}
 */
set showNotation(value: Boolean) {
    this._showNotation = value;
    if(this.board) this.load();
    this.showNotationChange.emit(this._showNotation);
  }
/**
 * @param {?} value
 * @return {?}
 */
set draggable(value: Boolean) {
    this._draggable = value;
    if(this.board) this.load();
    this.draggableChange.emit(this._draggable);
  }
/**
 * @param {?} value
 * @return {?}
 */
set dropOffBoard(value: string) {
    this._dropOffBoard = value;
    if(this.board) this.load();
    this.dropOffBoardChange.emit(this._dropOffBoard);
  }
/**
 * @param {?} value
 * @return {?}
 */
set pieceTheme(value: any) {
    this._pieceTheme = value instanceof Function ? value() : value;
    if(this.board) this.load();
    this.pieceThemeChange.emit(this._pieceTheme);
  }
/**
 * @param {?} value
 * @return {?}
 */
set moveSpeed(value: any) {
    this._moveSpeed = value;
    if(this.board) this.load();
    this.moveSpeedChange.emit(this._moveSpeed);
  }
/**
 * @param {?} value
 * @return {?}
 */
set snapbackSpeed(value: any) {
    this._snapbackSpeed = value;
    if(this.board) this.load();
    this.snapbackSpeedChange.emit(this._snapbackSpeed);
  }
/**
 * @param {?} value
 * @return {?}
 */
set snapSpeed(value: any) {
    this._snapSpeed = value;
    if(this.board) this.load();
    this.snapSpeedChange.emit(this._snapSpeed);
  }
/**
 * @param {?} value
 * @return {?}
 */
set sparePieces(value: Boolean) {
    this._sparePieces = value;
    if(this.board) this.load();
    this.sparePiecesChange.emit(this._sparePieces);
  }
/**
 * @return {?}
 */
get position():      any     { return this._position;      }
/**
 * @return {?}
 */
get orientation():   Boolean { return this._orientation;   }
/**
 * @return {?}
 */
get showNotation():  Boolean { return this._showNotation;  }
/**
 * @return {?}
 */
get draggable():     Boolean { return this._draggable;     }
/**
 * @return {?}
 */
get dropOffBoard():  string  { return this._dropOffBoard;  }
/**
 * @return {?}
 */
get pieceTheme():    any     { return this._pieceTheme;    }
/**
 * @return {?}
 */
get moveSpeed():     any     { return this._moveSpeed;     }
/**
 * @return {?}
 */
get snapbackSpeed(): any     { return this._snapbackSpeed; }
/**
 * @return {?}
 */
get snapSpeed():     any     { return this._snapSpeed;     }
/**
 * @return {?}
 */
get sparePieces():   Boolean { return this._sparePieces;   }

   positionChange:      EventEmitter<any>     = new EventEmitter<any>();
   orientationChange:   EventEmitter<Boolean> = new EventEmitter<Boolean>();
   showNotationChange:  EventEmitter<Boolean> = new EventEmitter<Boolean>();
   draggableChange:     EventEmitter<Boolean> = new EventEmitter<Boolean>();
   dropOffBoardChange:  EventEmitter<string>  = new EventEmitter<string>();
   pieceThemeChange:    EventEmitter<any>     = new EventEmitter<any>();
   moveSpeedChange:     EventEmitter<any>     = new EventEmitter<any>();
   snapbackSpeedChange: EventEmitter<any>     = new EventEmitter<any>();
   snapSpeedChange:     EventEmitter<any>     = new EventEmitter<any>();
   sparePiecesChange:   EventEmitter<Boolean> = new EventEmitter<Boolean>();
/**
 * @return {?}
 */
public clear() {
    this.board.clear(this.animation);
  }
/**
 * @param {?} notation
 * @return {?}
 */
public move(notation: string) {
    this.board.move(notation);
  }

  // EVENTS

   change:      EventEmitter<Object> = new EventEmitter<Object>();
   dragStart:   EventEmitter<Object> = new EventEmitter<Object>();
   dragMove:    EventEmitter<Object> = new EventEmitter<Object>();
   drop:        EventEmitter<Object> = new EventEmitter<Object>();
   snapbackEnd: EventEmitter<Object> = new EventEmitter<Object>();
   moveEnd:     EventEmitter<Object> = new EventEmitter<Object>();
/**
 * @param {?} oldPos
 * @param {?} newPos
 * @return {?}
 */
private onChangeHandler(oldPos: any, newPos: any) {
    this.change.emit({oldPos, newPos});
  }
/**
 * @param {?} source
 * @param {?} piece
 * @param {?} position
 * @param {?} orientation
 * @return {?}
 */
private onDragStart(source: string, piece: string, position: any, orientation: string) {
    this.dragStart.emit({source, piece, position, orientation});
  }
/**
 * @param {?} newLocation
 * @param {?} oldLocation
 * @param {?} source
 * @param {?} piece
 * @param {?} position
 * @param {?} orientation
 * @return {?}
 */
private onDragMove(newLocation: any, oldLocation: any, source: string, piece: string, position: any, orientation: string) {
    this.dragMove.emit({newLocation, oldLocation, source, piece, position, orientation});
  }
/**
 * @param {?} source
 * @param {?} target
 * @param {?} piece
 * @param {?} newPos
 * @param {?} oldPos
 * @param {?} orientation
 * @return {?}
 */
private onDrop(source: string, target: string, piece: string, newPos: any, oldPos: any, orientation: string) {
    this._position = newPos;
    this.positionChange.emit(this._position);
    this.drop.emit({source, target, piece, newPos, oldPos, orientation});
  }
/**
 * @param {?} piece
 * @param {?} square
 * @param {?} position
 * @param {?} orientation
 * @return {?}
 */
private onSnapbackEnd(piece: string, square: string, position: any, orientation: string) {
    this.snapbackEnd.emit({piece, square, position, orientation});
  }
/**
 * @param {?} oldPos
 * @param {?} newPos
 * @return {?}
 */
private onMoveEnd(oldPos: any, newPos: any) {
    this._position = newPos;
    this.positionChange.emit(this._position);
    this.moveEnd.emit({oldPos, newPos});
  }
/**
 * @return {?}
 */
private load() {
    this.board = ChessBoard('ng2-board', {
      'position': this._position,
      'orientation': this._orientation ? 'white' : 'black',
      'showNotation': this._showNotation,
      'draggable': this._draggable,
      'dropOffBoard': this._dropOffBoard,
      'pieceTheme': this._pieceTheme,
      'moveSpeed': this._moveSpeed,
      'snapbackSpeed': this._snapbackSpeed,
      'snapSpeed': this._snapSpeed,
      'sparePieces': this._sparePieces,

      'onDragStart': this.onDragStart.bind(this),
      'onChange': this.onChangeHandler.bind(this),
      'onDragMove': this.onDragMove.bind(this),
      'onDrop': this.onDrop.bind(this),
      'onSnapbackEnd': this.onSnapbackEnd.bind(this),
      'onMoveEnd': this.onMoveEnd.bind(this)
    });
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.load();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng2-chessboard',
  template: `
    <div id="ng2-board" style="width:500px"></div>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animation': [{ type: Input },],
'animationChange': [{ type: Output },],
'onResize': [{ type: HostListener, args: ['window:resize', ['$event'], ] },],
'position': [{ type: Input },],
'orientation': [{ type: Input },],
'showNotation': [{ type: Input },],
'draggable': [{ type: Input },],
'dropOffBoard': [{ type: Input },],
'pieceTheme': [{ type: Input },],
'moveSpeed': [{ type: Input },],
'snapbackSpeed': [{ type: Input },],
'snapSpeed': [{ type: Input },],
'sparePieces': [{ type: Input },],
'positionChange': [{ type: Output },],
'orientationChange': [{ type: Output },],
'showNotationChange': [{ type: Output },],
'draggableChange': [{ type: Output },],
'dropOffBoardChange': [{ type: Output },],
'pieceThemeChange': [{ type: Output },],
'moveSpeedChange': [{ type: Output },],
'snapbackSpeedChange': [{ type: Output },],
'snapSpeedChange': [{ type: Output },],
'sparePiecesChange': [{ type: Output },],
'change': [{ type: Output },],
'dragStart': [{ type: Output },],
'dragMove': [{ type: Output },],
'drop': [{ type: Output },],
'snapbackEnd': [{ type: Output },],
'moveEnd': [{ type: Output },],
};
}

function ChessboardComponent_tsickle_Closure_declarations() {
/** @type {?} */
ChessboardComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ChessboardComponent.ctorParameters;
/** @type {?} */
ChessboardComponent.propDecorators;
/** @type {?} */
ChessboardComponent.prototype.board;
/** @type {?} */
ChessboardComponent.prototype._position;
/** @type {?} */
ChessboardComponent.prototype._orientation;
/** @type {?} */
ChessboardComponent.prototype._showNotation;
/** @type {?} */
ChessboardComponent.prototype._draggable;
/** @type {?} */
ChessboardComponent.prototype._dropOffBoard;
/** @type {?} */
ChessboardComponent.prototype._pieceTheme;
/** @type {?} */
ChessboardComponent.prototype._moveSpeed;
/** @type {?} */
ChessboardComponent.prototype._snapbackSpeed;
/** @type {?} */
ChessboardComponent.prototype._snapSpeed;
/** @type {?} */
ChessboardComponent.prototype._sparePieces;
/** @type {?} */
ChessboardComponent.prototype.animation;
/** @type {?} */
ChessboardComponent.prototype.animationChange;
/** @type {?} */
ChessboardComponent.prototype.positionChange;
/** @type {?} */
ChessboardComponent.prototype.orientationChange;
/** @type {?} */
ChessboardComponent.prototype.showNotationChange;
/** @type {?} */
ChessboardComponent.prototype.draggableChange;
/** @type {?} */
ChessboardComponent.prototype.dropOffBoardChange;
/** @type {?} */
ChessboardComponent.prototype.pieceThemeChange;
/** @type {?} */
ChessboardComponent.prototype.moveSpeedChange;
/** @type {?} */
ChessboardComponent.prototype.snapbackSpeedChange;
/** @type {?} */
ChessboardComponent.prototype.snapSpeedChange;
/** @type {?} */
ChessboardComponent.prototype.sparePiecesChange;
/** @type {?} */
ChessboardComponent.prototype.change;
/** @type {?} */
ChessboardComponent.prototype.dragStart;
/** @type {?} */
ChessboardComponent.prototype.dragMove;
/** @type {?} */
ChessboardComponent.prototype.drop;
/** @type {?} */
ChessboardComponent.prototype.snapbackEnd;
/** @type {?} */
ChessboardComponent.prototype.moveEnd;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
